module.exports = __webpack_public_path__ + "img/lc-quxian.c007b135.png";